import React, { useState } from "react";
import "./../styles/PriceOffer.scss";
import pppng from "../img/pppng.png";
import mailpngg from "../img/mailpngg.png";
import telefonpng from "../img/telefonpng.png";
import cveklepng from "../img/cveklepng.png";
import locationpng from "../img/locationpng.png";
import positionpng from "../img/positionpng.png";
import downarrowpng from "../img/downarrowpng.png";
import rightarrowpng from "../img/rightarrowpng.png";
import pickcertificate from "../img/pickcertificate.png";
import inputareapng from "../img/inputareapng.png";
import mobilephonepng from "../img/mobilephonepng.png";
import taxpng from "../img/taxpng.png";
import atpng from "../img/atpng.png";
import Api from "../common/api";

import { GoogleReCaptchaProvider, GoogleReCaptcha } from "react-google-recaptcha-v3";

const GreenEnergyOffer = () => {
  const [isActive, setIsActive] = useState(false);
  const lang = localStorage.getItem("lang");
  
  const [token, setToken] = useState("");
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  const phoneNumberHandler = (e) => {
    if (e.target.value.length === 11) {
      var phoneInput = e.target.value.match(/(\d{1})(\d{3})(\d{3})(\d{4})/);
      phoneInput = phoneInput[1] + "(" + phoneInput[2] + ")" + " - " + phoneInput[3] + " " + phoneInput[4];
      e.target.value = phoneInput;
    } else {
      return;
    }
  }
  /*
  const emailHandler = (e) => {
    var deneme = e.target.value;
    if (deneme.length > 1 && !deneme.includes('@')) {
      e.target.value = e.target.value + "@";
    } else {
      return;
    }
  }
  */

  const [cities, setCities] = useState([])
  const [towns, setTowns] = useState([])
  const [info, setInfo] = useState(false)
  const [validateError, setValidateError] = useState(false)
  React.useEffect(() => {
    Api.get("/home/getcities/").then((res) => {
      setCities(res.data.cities)
    });
  }, []);

  const selectedCity = (e) => {
    Api.post("/home/GetCityTowns/"+e).then((res) => {
      setTowns(res.data.towns)
    });
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    let data = {
      email:e.target.email.value,
      name:e.target.name.value,
      company:e.target.company.value,
      companyphone:e.target.companyphone.value,
      city:e.target.city.options[e.target.city.selectedIndex].text,
      //certificate:e.target.certificate.value,
      certificate: e.target.certificate.options[e.target.certificate.selectedIndex].text,
      invoice:e.target.invoice.value,
      position:e.target.position.value,
      mobilephone:e.target.mobilephone.value,
      taxadmit:e.target.taxadmit.value,
      taxno:e.target.taxno.value,
      companyfax:e.target.companyfax.value,
      postcode:e.target.postcode.value,
      address:e.target.address.value,
      message:e.target.message.value,
      distcompany:e.target.distcompany.value,
      category:e.target.category.value,
      industry:e.target.industry.value,
      token: token
    }
    Api.post("/home/SendMail/",data).then((res) => {
      if (res.data.status) {
        setInfo(true)
        setValidateError(false)
      }
      else{
        setInfo(false)
        setValidateError(true)
      }
    });
  }
  const setTokenFunc = (getToken) => {
    setToken(getToken);
  };

  return (
    <form onSubmit={handleSubmit}>
      {info ? (
        <p className="info-content">İstek Başarıyla Gönderilmiştir</p>
      ) :""}
      {
        validateError ? (<p className="info-content">Google kepçe validasyonu yapılamadı</p>) : ""
      }
      <div className="form-section">
        <div className="input-container">
          <input
            className="form-input green"
            placeholder={lang =="en"? "Name - Surname ":"Adınız - Soyadınız"}
            type="text"
            name="name"
            required
          />
          <img src={pppng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input
            className="form-input green"
            type="email"
            placeholder="xxx@xxxx.xxx"
            required
            name="email"
            //onChange={(e) => emailHandler(e)}
          />
          <img src={mailpngg} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input
            className="form-input green"
            placeholder={lang =="en"? "Company Name ":"Şirket İsmi"}
            type="text"
            name="company"
            required
          />
          <img src={positionpng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input
            className="form-input green"
            placeholder={lang =="en"? "Business Phone ": "Şirket Telefonu"}
            type="number"
            name="companyphone"
            required
          />
          <img src={telefonpng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <select
            className="form-input green-select "
            id="city"
            name="city"
            required
            onChange={e => selectedCity(e.target.value)}
            >
              <option  value="s">
              {lang =="en"? "City ":"İl Seçiniz"}
              </option>
              {cities ? cities.map((data) => (
                <option value={data.Value}>
                {data.Text}
                </option>
              )):""}
          </select>
          <span className="select-span"></span>
          <img src={locationpng} alt="asda" />
        </div>
        <div className="input-container">
          <select
            className="form-input green-select"
            id="certificate"
            name="certificate"
          >
            <option style={{ padding: "15px 20px" }} value="s">
            {lang =="en"? "Preferred Certificate":"Tercih Edeceğiniz Sertifika Var mı?"}
            </option>
            <option style={{ padding: "15px 20px" }} value="1">
            {lang =="en"? "Gold Standard":"Gold Standard"}
            </option>
            <option style={{ padding: "15px 20px" }} value="2">
            {lang =="en"? "Verified Carbon Standard (VCS)":"Verified Carbon Standard (VCS)"}
            </option>
            <option style={{ padding: "15px 20px" }} value="3">
            {lang =="en"? "I-REC":"I-REC"}
            </option>
            <option style={{ padding: "15px 20px" }} value="4">
            {lang =="en"? "No choice":"Yok"}
            </option>
          </select>
          <span className="select-span"></span>
          <img src={pickcertificate} alt="asda" />
        </div>
        <div className="input-container">
          <input type="file" name="invoice" id="invoice" hidden accept="image/png, image/gif, image/jpeg, application/pdf"></input>
          <input
            className="cv-add-input green hidden"
            placeholder={lang =="en"? "Add Receipt": "Fatura Eklemek İstiyorum"}
            name="invoiceBox"
          />
          <span></span>
          <label for="invoice" className="file-picker">{lang =="en"? "Choose File":"Dosya Seç"}</label>
          {/* <button for="invoice" className="file-picker">{lang =="en"? "Choose File":"Dosya Seç"}</button> */}
          <img src={cveklepng} alt="asda" />
        </div>
      </div>
      <button onClick={() => setIsActive(!isActive)} className="only-text-btn">
        <img src={downarrowpng} alt="asd" />
        {lang =="en"? "Click here to fill optional fields": "İsteğe bağlı bilgileri doldurmak için tıklayınız."}
      </button>
      <div
        className={
          isActive ? "form-section second" : "form-section second display-none"
        }
      >
        <div className="input-container">
          <input className="form-input" name="position" placeholder={lang =="en"? "Position":"Göreviniz"} />
          <img src={positionpng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input className="form-input" onChange={(e) => phoneNumberHandler(e)}
            id="phoneNumber"
            placeholder="(5xx)-xxx-xx-xx"
            type="text"
            name="mobilephone"
             />
          <img src={mobilephonepng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input className="form-input" name="taxadmit" placeholder={lang =="en"? "Tax Administration":"Vergi Dairesi"} />
          <img src={taxpng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input className="form-input" name="taxno" placeholder={lang =="en"? "Tax Number":"Vergi No"} />
          <img src={taxpng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input className="form-input" name="companyfax" placeholder={lang =="en"? "Fax":"Şirket Faks"} />
          <img src={positionpng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-container">
          <input className="form-input" name="postcode" placeholder={lang =="en"? "Post Code":"Posta Kodu"} />
          <img src={atpng} alt="asda" />
          <span className="more-left"></span>
        </div>
        <div className="input-group small">
          <div className="icon">
            <img src={locationpng} alt="sd" />
            <span src="more-left"></span>
          </div>
          <textarea placeholder={lang =="en"? "Address":"Adres"} name="address" />
        </div>
        <div className="input-group small">
          <div className="icon">
            <img src={inputareapng} alt="sd" />
            <span src="more-left"></span>
          </div>
          <textarea placeholder={lang =="en"? "Note":"Notunuz"}  name="message"/>
        </div>
        <div
          style={{ width: "98%" }}
          className="input-group flex-grow full-width-two"
        >
          <div className="icon">
            <img src={rightarrowpng} alt="sd" />
            <span src="more-left"></span>
          </div>
          <select className="form-input-select" name="distcompany" id="distcompany">
            <option style={{ padding: "15px 20px" }} value="">
             
              {lang =="en"? "Choose Company":" Dağıtım Şirketi Seçiniz"}
            </option>
            <option value="AKDENİZ">AKDENİZ ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="ARAS">ARAS ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="AYDEM">AYDEM ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="ANADOLU">
              ANADOLU YAKASI ELEKTRİK DAĞITIM A.Ş.
            </option>
            <option value="BAŞKENT">BAŞKENT ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="BOĞAZİÇİ">BOĞAZİÇİ ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="ÇAMLIBEL">ÇAMLIBEL ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="ÇORUH">ÇORUH ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="DİCLE">DİCLE ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="FIRAT">FIRAT ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="GEDİZ">GEDİZ ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="AKEDAŞ">AKEDAŞ ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="KAYSERİ">KAYSERİ ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="MERAM">MERAM ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="OSMANGAZİ">OSMANGAZİ ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="SAKARYA">SAKARYA ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="TOROSLAR">TOROSLAR ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="TRAKYA">TRAKYA ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="ULUDAĞ">ULUDAĞ ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="VANGÖLÜ">VANGÖLÜ ELEKTRİK DAĞITIM A.Ş.</option>
            <option value="ÇALIK">
              ÇALIK YEŞİLIRMAK ELEKTRİK DAĞITIM A.Ş.
            </option>
            <option value="ELAZIĞ">ELAZIĞ ORGANİZE SANAYİ BÖLGESİ</option>
            <option value="Adıyaman">Adıyaman OSB</option>
            <option value="İNEGÖL">İNEGÖL OSB</option>
            <option value="12">12. BÖLGE MÜDÜRLÜĞÜ</option>
            <option value="SİVAS">SİVAS OSB</option>
            <option value="ORDU_OSB">ORDU_OSB</option>
            <option value="Şanlıurfa">Şanlıurfa OSB</option>
          </select>
        </div>
        <div className="input-container">
        <select
            className="form-input-select "
            id="category"
            name="category"
          >
            <option style={{ padding: "15px 20px" }} value="s">
            {lang =="en"? "Choose Category":"Kategori Seçiniz"}
            </option>
            <option value="1">Alternatif</option>
            <option value="1">Sanayi</option>
            <option value="1">Ticarethane</option>
            <option value="1">Mesken</option>
            <option value="1">Tarimsal Sulama</option>
            <option value="1">Aydinlatma</option>
            <option value="1">Diger</option>
            <option value="1">Ticarethane-Resmi (Ayedaş için)</option>
            <option value="1">Ticarethane-Diger-1 (Coruh için)</option>
            <option value="1">Ticarethane-Genel (Gediz için)</option>
            <option value="1">Ticarethane-Market</option>
            <option value="1">Ticarethane-Resmi Daire</option>
            <option value="1">Ticarethane-Santiye</option>
            <option value="1">Ticarethane-Otel</option>
            <option value="1">Ticarethane-Market (Aras için)</option>
            <option value="1">Ticarethane-Genel (Baskent için)</option>
            <option value="1">
              Ticarethane-Genel-1-Is Merkezi (Baskent için)
            </option>
            <option value="1">Ticarethane-Genel-2-Market (Baskent için)</option>
            <option value="1">
              Ticarethane-Genel-3-Alisveris Merkezi (Baskent için)
            </option>
            <option value="1">Ticarethane-Diger-1 (Baskent için)</option>
            <option value="1">Ticarethane-Diger-2 (Baskent için)</option>
            <option value="1">Sanayi-Soguk Hava (Gediz için)</option>
            <option value="1">Ticarethane-Banka</option>
            <option value="1">Ticarethane-Baz Istasyonu</option>
            <option value="1">Ticarethane-Hastane</option>
            <option value="1">Ticarethane-Otel-Metropol (Gediz için)</option>
            <option value="1">Ticarethane-Otel-Turistik (Gediz için)</option>
            <option value="1">Ticarethane-Baz Istasyonu (Sakarya için)</option>
            <option value="1">Ticarethane-Banka</option>
            <option value="1">Ticarethane-Otel</option>
            <option value="1">Ticarethane-Özel Hastane (Sakarya için)</option>
            <option value="1">
              Ticarethane-Genel Büro Yaz. (Sakarya için)
            </option>
            <option value="1">Ticarethane-Market-AG</option>
            <option value="1">
              Ticarethane-Akaryakit Istasyonu (Sakarya için)
            </option>
            <option value="1">
              Ticarethane-Içme Suyu Terfi (Sakarya için)
            </option>
            <option value="1">Sanayi-AG</option>
            <option value="1">Sanayi-OG</option>
            <option value="1">Sanayi-Içme Suyu Aritma (Sakarya için)</option>
            <option value="1">Aydinlatma-Belediye-Sokak (Sakarya için)</option>
            <option value="1">Aydinlatma-Tünel (Sakarya için)</option>
            <option value="1">Ticarethane-Market (Yesilirmak için)</option>
            <option value="1">Mesken-Yazlik(Gediz için)</option>
            <option value="1">Ticarethane-Hizmet Binasi(Meram için)</option>
            <option value="1">Ticarethane-Otel(Meram için)</option>
            <option value="1">Sanayi-Cift Vardiya</option>
            <option value="1">Ticarethane-Diger(Sakarya için)</option>
            <option value="1">
              Ticarethane-Alisveris Merkezi-Market(Sakarya için)
            </option>
            <option value="1">Ticarethane-Avm</option>
            <option value="1">Ticarethane-Hastane(Osmangazi için)</option>
            <option value="1">Ticarethane-Otel(Osmangazi için)</option>
            <option value="1">Ticarethane-Market(Trakya için)</option>
            <option value="1">Ticarethane-Baz Istasyonu(Trakya için)</option>
            <option value="1">Ticarethane-Hastane(Trakya için)</option>
            <option value="1">
              Ticarethane-Alisveris Merkezi(Trakya için)
            </option>
            <option value="1">Ticarethane-Avm(Uludag için)</option>
            <option value="1">Ticarethane-Avm(Gediz için)</option>
            <option value="1">Ticarethane-Özel Okul(Gediz için)</option>
            <option value="1">Ticarethane-Şantiye(Meram için)</option>
            <option value="1">Ticarethane-Cezaevi(Sakarya için)</option>
            <option value="1">Ticarethane-Kümes Hay.(Sakarya için)</option>
            <option value="1">Ticarethane-ÖğrenciYurdu(Sakarya için)</option>
            <option value="1">Ticarethane-Hastane</option>
            <option value="1">Ticarethane-Resmi Daire(Sakarya için)</option>
            <option value="1">Ticarethane-Hastane(Uludağ için)</option>
            <option value="1">Ticarethane-Otel(Uludağ için)</option>
            <option value="1">Mesken-Isı Merkezi(Başkent için)</option>
            <option value="1">Mesken-Mesken Özel(Kcetaş için)</option>
            <option value="1">Ticarethane-Otel-Yurt(Sakarya için)</option>
            <option value="1">Ticarethane-Market(Boğaziçi Edaş için)</option>
            <option value="1">
              Ticarethane-Plaza ve İŞ Merkezi(Boğaziçi Edaş için)
            </option>
            <option value="1">Ticarethane-AVM ve Market</option>
            <option value="1">Ticarethane-AVM ve Market</option>
            <option value="1">
              Ticarethane-Alçak Gerilim AVM-Market(Sakarya için)
            </option>
            <option value="1">Ticarethane - AG</option>
            <option value="1">
              Ticarethane-Baz İstasyonu-Telekom Santrali(Sakarya için)
            </option>
            <option value="1">
              Ticarethane-Meslek Lisesi-Meslek Yüksek Okulu(Sakarya için)
            </option>
            <option value="1">
              Ticarethane-Orta Gerilim AVM-Market(Sakarya için)
            </option>
            <option value="1">
              Aydınlatma-Sürekli Yük Çeken(Sakarya için)
            </option>
            <option value="1">Aydınlatma-Tünel(Yeşilırmak için)</option>
            <option value="1">Ticarethane-AVM</option>
            <option value="1">Ticarethane-Plaza</option>
            <option value="1">Ticarethane-Üniversite</option>
            <option value="1">Tarımsal Sulama - OG</option>
            <option value="1">Ticarethane - OG</option>
            <option value="1">Tarımsal Sulama - AG</option>
            <option value="1">Ticarethane-Banka-AG</option>
            <option value="1">Ticarethane-Banka-OG</option>
            <option value="1">Ticarethane-Market-OG</option>
            <option value="1">Ticarethane-Otel-AG</option>
            <option value="1">Ticarethane-Otel-OG</option>
            <option value="1">Ticarethane-Alt Yapı İşletmeleri-AG</option>
            <option value="1">Ticarethane-Alt Yapı İşletmeleri-OG</option>
            <option value="1">Ticarethane-AVM ve Diğer İş Merkezleri-AG</option>
            <option value="1">Ticarethane-AVM ve Diğer İş Merkezleri-OG</option>
            <option value="1">
              Ticarethane-Banka ve Sigorta İşletmeleri-AG
            </option>
            <option value="1">
              Ticarethane-Banka ve Sigorta İşletmeleri-OG
            </option>
            <option value="1">
              Ticarethane-Eğitim Kurum ve İşletmeleri-AG
            </option>
            <option value="1">
              Ticarethane-Eğitim Kurum ve İşletmeleri-OG
            </option>
            <option value="1">Ticarethane-Plaza ve İş Merkezi-AG</option>
            <option value="1">Ticarethane-Plaza ve İş Merkezi-OG</option>
            <option value="1">Ticarethane-Sağlık İşletmeleri-AG</option>
            <option value="1">Ticarethane-Sağlık İşletmeleri-OG</option>
            <option value="1">Ticarethane-Alt Yapı İşletmeleri</option>
            <option value="1">Ticarethane-Eğitim ve Sağlık Hizmetleri</option>
            <option value="1">Ticarethane-Mağaza ve Marketler</option>
            <option value="1">Ticarethane-Haberleşme</option>
            <option value="1">Ticarethane-Okul</option>
            <option value="1">Aydinlatma - ADANA</option>
            <option value="1">Aydinlatma - ADIYAMAN</option>
            <option value="1">Aydinlatma - AFYONKARAHİSAR</option>
            <option value="1">Aydinlatma - AĞRI</option>
            <option value="1">Aydinlatma - AMASYA</option>
            <option value="1">Aydinlatma - ANKARA</option>
            <option value="1">Aydinlatma - ANTALYA</option>
            <option value="1">Aydinlatma - ARTVİN</option>
            <option value="1">Aydinlatma - AYDIN</option>
            <option value="1">Aydinlatma - BALIKESİR</option>
            <option value="1">Aydinlatma - BİLECİK</option>
            <option value="1">Aydinlatma - BİNGÖL</option>
            <option value="1">Aydinlatma - BİTLİS</option>
            <option value="1">Aydinlatma - BOLU</option>
            <option value="1">Aydinlatma - BURDUR</option>
            <option value="1">Aydinlatma - BURSA</option>
            <option value="1">Aydinlatma - ÇANAKKALE</option>
            <option value="1">Aydinlatma - ÇANKIRI</option>
            <option value="1">Aydinlatma - ÇORUM</option>
            <option value="1">Aydinlatma - DENİZLİ</option>
            <option value="1">Aydinlatma - DİYARBAKIR</option>
            <option value="1">Aydinlatma - EDİRNE</option>
            <option value="1">Aydinlatma - ELAZIĞ</option>
            <option value="1">Aydinlatma - ERZİNCAN</option>
            <option value="1">Aydinlatma - ERZURUM</option>
            <option value="1">Aydinlatma - ESKİŞEHİR</option>
            <option value="1">Aydinlatma - GAZİANTEP</option>
            <option value="1">Aydinlatma - GİRESUN</option>
            <option value="1">Aydinlatma - GÜMÜŞHANE</option>
            <option value="1">Aydinlatma - HAKKARİ</option>
            <option value="1">Aydinlatma - HATAY</option>
            <option value="1">Aydinlatma - ISPARTA</option>
            <option value="1">Aydinlatma - MERSİN</option>
            <option value="1">Aydinlatma - İSTANBUL</option>
            <option value="1">Aydinlatma - İST.AVRUPA</option>
            <option value="1">Aydinlatma - İZMİR</option>
            <option value="1">Aydinlatma - KARS</option>
            <option value="1">Aydinlatma - KASTAMONU</option>
            <option value="1">Aydinlatma - KAYSERİ</option>
            <option value="1">Aydinlatma - KIRKLARELİ</option>
            <option value="1">Aydinlatma - KIRŞEHİR</option>
            <option value="1">Aydinlatma - KOCAELİ</option>
            <option value="1">Aydinlatma - KONYA</option>
            <option value="1">Aydinlatma - KÜTAHYA</option>
            <option value="1">Aydinlatma - MALATYA</option>
            <option value="1">Aydinlatma - MANİSA</option>
            <option value="1">Aydinlatma - KAHRAMANMARAŞ</option>
            <option value="1">Aydinlatma - MARDİN</option>
            <option value="1">Aydinlatma - MUĞLA</option>
            <option value="1">Aydinlatma - MUŞ</option>
            <option value="1">Aydinlatma - NEVŞEHİR</option>
            <option value="1">Aydinlatma - NİĞDE</option>
            <option value="1">Aydinlatma - ORDU</option>
            <option value="1">Aydinlatma - RİZE</option>
            <option value="1">Aydinlatma - SAKARYA</option>
            <option value="1">Aydinlatma - SAMSUN</option>
            <option value="1">Aydinlatma - SİİRT</option>
            <option value="1">Aydinlatma - SİNOP</option>
            <option value="1">Aydinlatma - SİVAS</option>
            <option value="1">Aydinlatma - TEKİRDAĞ</option>
            <option value="1">Aydinlatma - TOKAT</option>
            <option value="1">Aydinlatma - TRABZON</option>
            <option value="1">Aydinlatma - TUNCELİ</option>
            <option value="1">Aydinlatma - ŞANLIURFA</option>
            <option value="1">Aydinlatma - UŞAK</option>
            <option value="1">Aydinlatma - VAN</option>
            <option value="1">Aydinlatma - YOZGAT</option>
            <option value="1">Aydinlatma - ZONGULDAK</option>
            <option value="1">Aydinlatma - AKSARAY</option>
            <option value="1">Aydinlatma - BAYBURT</option>
            <option value="1">Aydinlatma - KARAMAN</option>
            <option value="1">Aydinlatma - KIRIKKALE</option>
            <option value="1">Aydinlatma - BATMAN</option>
            <option value="1">Aydinlatma - ŞIRNAK</option>
            <option value="1">Aydinlatma - BARTIN</option>
            <option value="1">Aydinlatma - ARDAHAN</option>
            <option value="1">Aydinlatma - IĞDIR</option>
            <option value="1">Aydinlatma - YALOVA</option>
            <option value="1">Aydinlatma - KARABÜK</option>
            <option value="1">Aydinlatma - KİLİS</option>
            <option value="1">Aydinlatma - OSMANİYE</option>
            <option value="1">Aydinlatma - DÜZCE</option>
            <option value="1">Ticarethane - OG (BTV%1)</option>
            <option value="1">Ticarethane-AG (BTV%1)</option>
            <option value="1">Sanayi OG_TRT Lİ</option>
            <option value="1">Tarımsal Sulama AG</option>
          </select>
          <span className="select-span"></span>
          <img src={rightarrowpng} alt="asda" />
        </div>
        <div className="input-container">
        <select
            className="form-input-select"
            id="industry"
            name="industry"
          >
            <option style={{ padding: "15px 20px" }} value="">
            {lang =="en"? "Choose Industry":" Endüstri Seçiniz"} 
            </option>
            <option value="1"> AVM</option>
            <option value="1"> EĞİTİM</option>
            <option value="1"> Kışlık Otel</option>
            <option value="1"> İnşaat</option>
            <option value="1"> İNŞAAT</option>
            <option value="1"> Perakende</option>
            <option value="1"> Matbaa</option>
            <option value="1"> MAĞAZACILIK</option>
            <option value="1"> Baz İstasyonu</option>
            <option value="1"> Yaz Turizmi</option>
            <option value="1"> AVM</option>
            <option value="1"> OTEL</option>
            <option value="1"> OTOMOTİV</option>
            <option value="1"> OSB</option>
            <option value="1"> Porselen Fabrikası</option>
            <option value="1"> Sağlık Hizmetleri</option>
            <option value="1"> Dernek</option>
            <option value="1"> SİTE-OFİS-PLAZA</option>
            <option value="1"> Restaurant</option>
            <option value="1"> Eğitim Kurumları</option>
            <option value="1"> Yol Yapım-Asfalt-Taş Kırma</option>
            <option value="1"> Residence Site</option>
            <option value="1"> Ambalaj kağıt</option>
            <option value="1"> Kamu</option>
            <option value="1"> İş Merkezi</option>
            <option value="1"> Gıda Tüketim</option>
            <option value="1"> Çimento Fabrikası</option>
            <option value="1"> Okul</option>
            <option value="1"> Tekstil</option>
            <option value="1"> PLASTİK BORU</option>
            <option value="1"> Diğer</option>
            <option value="1"> CC Diğer </option>
            <option value="1"> CC Akaryakıt</option>
            <option value="1"> CC Eğitim - Okul</option>
            <option value="1"> CC Elektrik - Elektronik Ürün Üretimi</option>
            <option value="1"> CC Gıda Üretim</option>
            <option value="1"> CC Hastane - Sağlık Merkezi</option>
            <option value="1"> CC Hayvancılık - Tarım İlaç</option>
            <option value="1">

              CC İlaç ve Ecza Depoları - Soğuk Hava Deposu
            </option>
            <option value="1"> CC İnşaat Malzemeleri Üretim</option>
            <option value="1"> CC Kimya, Petrol, Plastik Üretim</option>
            <option value="1"> CC Lojistik - Depo - Taşımacılık</option>
            <option value="1"> CC Lojistik Merkezleri - Fuar Alanları</option>
            <option value="1"> CC Ofis-Büro&Acente&Kobi Ofis</option>
            <option value="1"> CC Otel</option>
            <option value="1"> CC Restaurant -Cafe</option>
            <option value="1"> CC Tekstil Üretim </option>
            <option value="1"> CC Tershane - Liman - Marina</option>
            <option value="1"> CC Tıbbi Aletler - Optik Ürünler Üretim</option>
            <option value="1"> CC Zincir Market - Zincir Mağaza - AVM</option>
            <option value="1"> CC Çelik Maden Üretim </option>
          </select>
          <span className="select-span"></span>
          <img src={rightarrowpng} alt="asda" />
        </div>
      </div>
      <div className="input-check-one">
        <input type="checkbox" required />
        {lang  == "en" ? (
        <p>
          I wish to receive e-mails in line with the terms laid down in the   <a
            href="https://sankoenerji.com.tr/Uploads/MediaCenter/ENKO_Acik_Riza_Metni.pdf"
            target="_blank"
            style={{ color: "#255e85", textDecoration: "underline" }}
          >Consent Document </a> in order to be informed about important campaigns.
        </p>):(
          
        <p>
        Önemli kampanyalardan haberdar olmak için{" "}
        <a
          href="https://sankoenerji.com.tr/Uploads/MediaCenter/ENKO_Acik_Riza_Metni.pdf"
          target="_blank"
          style={{ color: "#255e85", textDecoration: "underline" }}
        >
          Rıza Metni
        </a>{" "}
        kapsamında elektronik ileti almak istiyorum.
      </p>

        )}
      </div>
      <div className="input-check-two">
        <input type="checkbox" required />
        {lang == "en" ? ( 
         
         <p>
              I have read and understood the
          <a
            target="_blank"
            href="https://sankoenerji.com.tr/Uploads/MediaCenter/ENKO_Elektrik-Almak-Istiyorum_-KVKK_Metni.pdf"
            style={{
              color: "#255e85",
              textDecoration: "underline",
              margin: "0 5px",
            }}
          >
           Clarification Notice.
          </a>
        </p>
        ):(

          <p>
            <a
              target="_blank"
              href="https://sankoenerji.com.tr/Uploads/MediaCenter/ENKO_Elektrik-Almak-Istiyorum_-KVKK_Metni.pdf"
              style={{
                color: "#255e85",
                textDecoration: "underline",
                margin: "0 5px",
              }}
            >
              Aydınlatma Metnini
            </a>
            okudum ve anladım.
          </p>
        )}
      </div>
      <button className="submit-btn right">{lang == "en"? "Send":"Gönder"}</button>
      <GoogleReCaptchaProvider reCaptchaKey="6Le11UcqAAAAAO6EIq84ShU5sO0Y-gvNgGSVcCbL">
      <GoogleReCaptcha
        className="google-recaptcha-custom-class"
        onVerify={setTokenFunc}
        refreshReCaptcha={refreshReCaptcha}
      />
    </GoogleReCaptchaProvider>
    </form>
  );
};

export default GreenEnergyOffer;
